import { computed, ref } from "vue";
import { useAuthStore } from "@/store/auth";
import { useBp } from "@/utils/breakpoints";
import { useShellVisibility } from "@/composables/useShellVisibility";

const isExpanded = ref(localStorage.getItem("sidebar-expanded") === "true");
// Mirrors --sidebar-width (written by App.vue) for layout math in JS.
export const sidebarWidthPx = ref(0);

export function useSidebarDock() {
  const authStore = useAuthStore();
  const bp = useBp();
  const { shouldShowNavbar } = useShellVisibility();

  const canToggle = computed(
    () => authStore.isAuthed && shouldShowNavbar.value && !bp.smaller.lg,
  );

  return { isExpanded, canToggle };
}
